// src/context/AuthContext.js
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

/* ---------- normalizzazioni ---------- */
function normalizeRole(r) {
  const s = String(r || "").trim().toLowerCase();
  if (!s) return "";
  if (["admin", "amministratore", "root"].includes(s)) return "admin";
  if (["callcenter", "call_center", "cc"].includes(s)) return "centralino";
  if (["trainer", "formatore"].includes(s)) return "formatore";
  if (
    [
      "responsabile",
      "responsabile_zona",
      "responsabile-di-zona",
      "responsabile di zona",
      "resp",
      "resp_zona",
      "manager_zona",
    ].includes(s)
  ) return "responsabile";
  if (["senior posa","senior-posa","senior_posa","seniorposa","tecnico posa","tecnico_posa","tecnicoposa","posa"].includes(s))
    return "senior_posa";
  return s;
}

function normalizeUser(u) {
  if (!u) return null;
  const role = normalizeRole(u.role_code ?? u.ruolo ?? u.role);
  const id = Number(u.id || 0) || null;
  const username = u.username ?? u.email ?? null;
  return { ...u, id, username, role, role_code: role };
}

/* ---------- contesto ---------- */
const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);
  const API = "/preventivi/api";

  async function login(email, password) {
    const r = await fetch(`${API}/login.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ email, password }),
    });
    const j = await r.json().catch(() => ({}));
    if (!r.ok || j?.status !== "OK") {
      throw new Error(j?.message || `HTTP ${r.status}`);
    }
    setUser(normalizeUser(j.user));
    return j.user;
  }

  async function me() {
    const r = await fetch(`${API}/me.php`, { credentials: "include", cache: "no-store" });
    const j = await r.json().catch(() => ({}));
    setUser(r.ok && j?.status === "OK" ? normalizeUser(j.user) : null);
    setReady(true);
  }

  async function logout() {
    try { await fetch(`${API}/logout.php`, { credentials: "include" }); } catch {}
    setUser(null);
  }

  useEffect(() => { me(); }, []);

  const ctx = useMemo(() => {
    const role = user?.role_code || "";
    const isAuthenticated = !!user?.id;
    const isAdmin = role === "admin";
    const isFormatore = role === "formatore";
    const hasRole = (...roles) => roles.map(normalizeRole).includes(role);
    return { user, ready, isAuthenticated, role, isAdmin, isFormatore, hasRole, login, logout };
  }, [user, ready]);

  return <AuthContext.Provider value={ctx}>{children}</AuthContext.Provider>;
}

export default AuthContext;
